import Layout from '@/layout/default'
import RouterView from '@@/compose/routerView.vue'

// 发起的项目
const ProjectManageRouter = {
    path: '/project_manage', 
    name: 'project_manage',
    component: Layout,
    children: [
        {
            path: 'index', // 概览
            name: 'index',
            component: RouterView,
            children: [{
                path: 'temp/:id', // 准备中的项目
                name: '项目概览',
                meta: {
                    promission: {
                        'menuName': 'index'
                    }
                },
                component: () => import('@/views/project_manage/index/_id.vue')
            },{
                path: ':id', // 概览
                name: '概览',
                meta: {
                    promission: {
                        'menuName': 'index'
                    }
                },
                component: () => import('@/views/project_manage/index/_id.vue')
            }]
        },
        {
            path: 'question/:id', // 常见问题
            name: '常见问题',
            meta: {
                promission: {
                    'menuName': 'question'
                }
            },
            component: () => import('@/views/project_manage/question/_id.vue')
        },
        {
            path: 'settlement', 
            name: 'settlement',
            children: [
                {
                    path: 'index/:id', // 结算管理
                    name: '结算管理',
                    meta: {
                        promission: {
                            'menuName': 'settlement',
                            'wdsMenu': false // 微打赏此菜单无权限
                        }
                    },
                    component: () => import('@/views/project_manage/settlement/index/_id.vue')
                },
                {
                    path: 'apply/:preview/:period/:id', // 项目结算单
                    name: '项目结算单',
                    meta: {
                        promission: {
                            'menuName': 'settlement',
                            'wdsMenu': false // 微打赏此菜单无权限
                        }
                    },
                    component: () => import('@/views/project_manage/settlement/apply/_id.vue')
                },
                {
                    path: 'rate/:id', // 结算费率
                    name: '结算费率',
                    meta: {
                        promission: {
                            'menuName': 'settlementRate',
                            'wdsMenu': false // 微打赏此菜单无权限
                        }
                    },
                    component: () => import('@/views/project_manage/settlement/rate/_id.vue')
                }
            ]
        },
        {
            path: 'order/:id', // 订单管理
            name: '订单管理',
            meta: {
                promission: {
                    'menuName': 'order'
                }
            },
          component: () => import('@/views/project_manage/order/_id.vue'),
        },
        {
            path: 'link', // 项目宣传链接
            name: 'link',
            children: [{
                path: 'kolinfo',
                name: 'kolinfo', // “达人/KOL”推广链接详情
                meta: {
                    promission: {
                        'menuName': 'link',
                        'wdsMenu': false // 微打赏此菜单无权限
                    }
                },
                component: () => import('@/views/project_manage/link/kolInfo.vue')
            },{
                path: 'kollist',
                name: '“达人/KOL”推广链接',
                meta: {
                    promission: {
                        'menuName': 'link',
                        'wdsMenu': false // “达人/KOL”推广链接
                    }
                },
                component: () => import('@/views/project_manage/link/kollist.vue')
            },{
                path: ':id',
                name: '项目宣传链接',
                meta: {
                    promission: {
                        'menuName': 'link',
                        'wdsMenu': false // 微打赏此菜单无权限
                    }
                },
                component: () => import('@/views/project_manage/link/_id.vue')
            }]
        },
        {
            path: 'analysis/:id', // 数据分析
            name: '数据分析',
            meta: {
                promission: {
                    'menuName': 'analysis'
                }
            },
            component: () => import('@/views/project_manage/analysis/_id.vue')
        },
        {
          path: 'deliver/:id', // 发货管理
          name: '发货管理',
          meta: {
            promission: {
                'menuName': 'deliver',
                'wdsMenu': false // 微打赏此菜单无权限
            }
          },
          component: () => import('@/views/project_manage/deliver/_id.vue')
        },
        {
            path: 'update', 
            name: 'update',
            children: [{
                path: 'index/:id',
                name: 'update-index',
                meta: {
                    title: '项目更新',
                    promission: {
                        'menuName': 'update'
                    }
                },
                component: () => import('@/views/project_manage/update/_id.vue')
            },{
                path: 'release_update',
                name: 'release_update',
                meta: {
                    title: '创建更新',
                    promission: {
                        'menuName': 'update'
                    }
                },
                component: () => import('@/views/project_manage/update/index.vue'),
            },{
                path: 'update_rule',
                name: 'update_rule',
                meta: {
                    title: '违规提示',
                    promission: {
                        'menuName': 'update'
                    }
                },
                component: () => import('@/views/project_manage/update/update_rule.vue'),
            },{
                path: 'update_list',
                name: 'update_list',
                meta: {
                    title: '历史更新',
                    promission: {
                        'menuName': 'update'
                    }
                },
                component: () => import('@/views/project_manage/update/update_list.vue'),
            },{
                path: 'draft_list',
                name: 'draft_list',
                meta: {
                    title: '草稿箱',
                    promission: {
                        'menuName': 'update'
                    }
                },
                component: () => import('@/views/project_manage/update/draft_list.vue'),
            },{
                path: 'pre_list',
                name: 'pre_list',
                meta: {
                    title: '待发布',
                    promission: {
                        'menuName': 'update'
                    }
                },
                component: () => import('@/views/project_manage/update/pre_list.vue'),
            }]
        },
        {
            path: 'after_sale/:id', // 售后管理
            name: 'after_sale',
            meta: {
                title: '售后管理',
                promission: {
                    'menuName': 'after_sale',
                    'wdsMenu': false // 微打赏此菜单无权限
                }
            },
            component: () => import('@/views/project_manage/after_sale/_id.vue')
        },
        {
            path: 'complain_manage/:id', // 工单管理
            name: 'complain_manage',
            meta: {
                title: '工单管理',
                promission: {
                    'menuName': 'complain_manage',
                    'wdsMenu': false // 微打赏此菜单无权限
                }
            },
            component: () => import('@/views/project_manage/complain_manage/_id.vue')
        },
        {
            path: 'supplemental_agreement/:id', // 上传补充文件
            name: 'supplemental_agreement',
            meta: {
                title: '上传补充文件',
                promission: {
                    'menuName': 'index',
                    'wdsMenu': false // 微打赏此菜单无权限
                }
            },
            redirect: (to) => {
                window.location.href = `https://account.modian.com/initiate/member?pro_id=${to.params.id}`;
                return false;
            }
        }
    ]
}

export default ProjectManageRouter
